import * as Constants from "../../Constants?v=0.0.2";

export let signIn = function (socialLogin, socialLoginVia, loginAppUrl) {
  if (socialLogin === true) {
    switch (socialLoginVia) {
        case "Google":
            window.gapi.load("auth2", function () {
                var auth2 = window.gapi.auth2.init({
                    client_id: "989193641893-et0sbj4cogdp7o60t0d5ug985074j43o.apps.googleusercontent.com",
                    scope: "profile",
                    ux_mode: "redirect",
                    redirect_uri: loginAppUrl + "/myPlan/login",
                });
                auth2.signIn().then(function () {});
            });
            break;
      default:
        break;
    }
  }
};

export let sendSignInData = function (
  socialLogin,
  loginAPI,
  myBooksURL,
  loginObject,
  User
) {
  fetch(loginAPI, {
    method: "POST",
    body: Constants.CreateData(User),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => res.json())
    .then(
      (result) => {
        if (result.dataStatus.isSuccess) {
          if (
            User.username === "sup.user@zetran.com" ||
            User.username === "sup.user@zetran.in"
          ) {
            let sessionId = result.payload.session_id;
            let encodedUserName = encodeURIComponent(User.username);
            let encodedPassword = encodeURIComponent(User.password);
            let validApplicationURL =
              myBooksURL +
              "?au=" +
              sessionId +
              "&username=" +
              encodedUserName +
              "&password=" +
              encodedPassword;
            window.location.href = validApplicationURL;
          } else {
            let sessionId = result.payload.session_id;
            let validApplicationURL = myBooksURL + "?au=" + sessionId;
            window.location.href = validApplicationURL;
          }
        } else {
        }
      },
      (error) => {
        console.log(error);
      }
    );
};
